module.exports = __webpack_public_path__ + "static/img/one.70acd760.png";